import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { tasks as tasksApi } from 'redux/modules/api'
import { combineAnd } from 'utils/apiFilter'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api, auth, app }) => ({
        tasksSectionSignoff: api.tasks.sectionSignoff,
        user: auth.user,
        commonLimit: app.commonLimit
      }),
      { ...tasksApi.sectionSignoff }
    )
    class TasksSectionSignoff extends Component {
      static propTypes = {
        tasks: PropTypes.object,
        decoFilterMyOnly: PropTypes.bool,
        tasksSectionSignoff: PropTypes.object.isRequired,
        getTasksSectionSignoff: PropTypes.func.isRequired,
        user: PropTypes.object,
        commonLimit: PropTypes.number,
        setSectionSignoffParams: PropTypes.func
      }

      defaultProps = {
        tasksActivityApproval: {}
      }

      componentDidMount() {
        let { tasksSectionSignoff } = this.props
        const { decoFilterMyOnly, commonLimit, setSectionSignoffParams } = this.props

        if (config.useCommonLimit && commonLimit) {
          tasksSectionSignoff = {
            ...tasksSectionSignoff,
            limit: commonLimit
          }
          setSectionSignoffParams({ limit: commonLimit })
        }

        config.list && this.handleGetTasksSectionSignoff(tasksSectionSignoff, decoFilterMyOnly)
      }

      componentWillReceiveProps(nextProps) {
        const { tasksSectionSignoff, decoFilterMyOnly } = this.props
        const { filter, limit, offset, sort } = nextProps.tasksSectionSignoff

        if (
          tasksSectionSignoff.filter !== filter ||
          tasksSectionSignoff.limit !== limit ||
          tasksSectionSignoff.offset !== offset ||
          tasksSectionSignoff.sort !== sort ||
          decoFilterMyOnly !== nextProps.decoFilterMyOnly
        ) {
          config.list &&
            this.handleGetTasksSectionSignoff(nextProps.tasksSectionSignoff, nextProps.decoFilterMyOnly)
        }
      }

      handleGetTasksSectionSignoff = (tasks, myOnly) => {
        const personId = this.props.user.personId
        const filterMyOnly = myOnly || this.props.decoFilterMyOnly
        const combinedFilter = combineAnd(tasks.filter,
          filterMyOnly
            ? `award.awardLeader.person.id=${personId}`
            : '')

        return this.props.getTasksSectionSignoff({ ...tasks, filter: combinedFilter })
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            tasks={{
              ...this.props.tasks,
              sectionSignoff: this.props.tasksSectionSignoff
            }}
          />
        )
      }
    }
    return TasksSectionSignoff
  }
}

export default decorator
